module.exports = __webpack_public_path__ + "static/media/Goodnest_ios_2_preview.e1c5849d.jpg";